/* eslint-disable react/function-component-definition */
import React, { useEffect } from 'react'
import { Task, ViewMode } from '@/components/Gantt/gantt-task-react'
import { ViewSwitcher } from './ViewSwitcher'
import { getTasks } from './Helpers'
import { GanttChart } from '@/components/Gantt'
import { useQuery } from 'react-query'
import { getOrderSectionSummaryByOrderId } from '../../../Order.transform'
import { Button } from 'antd'
import Fade from '@/components/Fade'
type GanttProps = {
  id: string
  onClickTimeline: (sectionId: string, taskId: string) => void
}
// Init
const App: React.FC<GanttProps> = ({ id, onClickTimeline }) => {
  const { data } = useQuery('SECTION_SUMMARIES', async () => {
    return await getOrderSectionSummaryByOrderId(id)
  })

  const [view, setView] = React.useState<ViewMode>(ViewMode.Month)
  const [tasks, setTasks] = React.useState<Task[]>()
  const [summaryData, setSummaryData] = React.useState<{
    all_tasks: 0
    done: 0
    not_planned: 0
    overdue_tasks: 0
    planned: 0
    upcoming: 0
  }>()
  useEffect(() => {
    if (data && data.sections) {
      const tasks = getTasks(data.sections)
      setTasks(tasks)
      setSummaryData(data.filter)
    }
  }, [data])

  const handleExpanderClick = (task: Task) => {
    setTasks(tasks.map((t) => (t.id === task.id ? task : t)))
  }
  const handleToggleCollapseAll = (status: boolean) => {
    setTasks(
      tasks.map((t) => {
        t.hideChildren = status
        return t
      })
    )
  }
  const handleCollapseAll = () => {
    handleToggleCollapseAll(true)
  }
  const handleExpandAll = () => {
    handleToggleCollapseAll(false)
  }

  const handleTaskClick = (task: Task) => {
    const isClickSection = data.sections.some((item) => item.id == task.id)
    if (isClickSection) {
      onClickTimeline(task.id, '')
    } else {
      let sectionId = ''
      for (const section of data.sections) {
        for (const tasks of section.tasks) {
          if (tasks.id == task.id) {
            sectionId = section.id
          }
        }
      }
      onClickTimeline(sectionId, '')
    }
  }
  const onViewStatusChange = (status: string) => {
    const resSections = data.sections
    if (status === 'all') {
      const sections = getTasks(resSections)
      setTasks(sections)
    } else {
      const statusArr = status.split(',')

      const tempSections = resSections.filter((section) =>
        section.tasks.some((task) => statusArr.includes(task.result))
      )
      tempSections.push(resSections[resSections.length - 1])
      const sections = getTasks(tempSections)
      const newTasks = sections.filter(
        (t) => statusArr.includes(t.status) || t.type === 'project'
      )
      setTasks(
        newTasks.map((t) => {
          t.hideChildren = false
          return t
        })
      )
    }
  }

  return tasks ? (
    <Fade>
      <div className="wrapper">
        <div>
          <ViewSwitcher
            onViewModeChange={(viewMode) => setView(viewMode)}
            onViewStatusChange={onViewStatusChange}
            summaryData={summaryData}
          />
        </div>
        <div style={{ marginBottom: '15px' }}>
          <Button onClick={handleExpandAll} type="text">
            Expand all
          </Button>
          <Button onClick={handleCollapseAll} type="text">
            Collapse all
          </Button>
        </div>
        <div>
          <GanttChart
            deliveryDate={
              data?.sections?.find((item) => item.name == 'Delivery')
                ?.plan_start_date
            }
            tasks={tasks}
            viewMode={view}
            onTaskClick={handleTaskClick}
            onBarClick={handleTaskClick}
            onExpanderClick={handleExpanderClick}
          />
        </div>
      </div>
    </Fade>
  ) : (
    <div />
  )
}

export default App
